var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('AboutusMobile',_vm._b({},'AboutusMobile',{ info: _vm.info },false)):_c('AboutusPc',_vm._b({},'AboutusPc',{ info: _vm.info },false))
}
var staticRenderFns = []

export { render, staticRenderFns }